import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <nav className="border-b border-border/50 backdrop-blur-sm sticky top-0 z-40 bg-background/80">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
          <Link to="/" aria-label="Home"><Logo variant="full" className="h-12 sm:h-14 object-contain" /></Link>
          <Link to="/pricing"><Button variant="ghost" size="sm">Pricing</Button></Link>
        </div>
      </nav>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-invert prose-headings:font-display prose-headings:font-bold prose-h1:text-4xl prose-h2:text-2xl prose-h2:mt-10 prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary">
        <h1>Terms &amp; Conditions</h1>
        <p className="text-sm">Last updated: April 28, 2026</p>

        <h2>1. Who you are contracting with</h2>
        <p>
          These Terms govern your use of Pull Over Sales (the "Service"), provided by
          <strong> Pull Over Sales</strong> ("we", "us", "our"). By creating an account or using
          the Service you agree to these Terms.
        </p>

        <h2>2. The Service</h2>
        <p>
          Pull Over Sales is a sales-floor activity tracking and pipeline tool for automotive sales
          teams and independent reps. Features include deal management, activity logging, push
          notifications, leaderboards, customer feedback (CSI) collection, and manager dashboards.
        </p>

        <h2>3. Your account</h2>
        <ul>
          <li>You must be of legal age and, if signing up on behalf of a dealership, authorised to bind it.</li>
          <li>You are responsible for keeping your credentials confidential and for activity under your account.</li>
          <li>You agree to provide accurate information and keep it up to date.</li>
        </ul>

        <h2>4. Acceptable use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service unlawfully, fraudulently, or to send spam.</li>
          <li>Infringe any intellectual-property or privacy rights.</li>
          <li>Probe, scan, scrape, or interfere with the Service or attempt to introduce malware.</li>
          <li>Reverse engineer the Service, resell it, or circumvent its technical limits.</li>
          <li>Upload customer or personal data you do not have the right to process.</li>
        </ul>

        <h2>5. Intellectual property</h2>
        <p>
          We retain all rights in the Service, including software, branding, and documentation. We
          grant you a limited, non-exclusive, non-transferable right to use the Service within your
          chosen plan. You retain rights in the customer and deal data you input; you grant us a
          limited licence to host and process it solely to provide the Service.
        </p>

        <h2>6. Payments, subscriptions, and refunds</h2>
        <p>
          Our order process is conducted by our online reseller <strong>Paddle.com</strong>.
          Paddle.com is the Merchant of Record for all our orders. Paddle provides all customer
          service inquiries and handles returns. Payment, billing, tax, cancellation, and refund
          mechanics are governed by{" "}
          <a href="https://www.paddle.com/legal/checkout-buyer-terms" target="_blank" rel="noreferrer">
            Paddle's Buyer Terms
          </a>. See also our <Link to="/refunds">Refund Policy</Link>.
        </p>

        <h2>7. Service level</h2>
        <p>
          We work hard to keep Pull Over Sales available and accurate, but we do not guarantee that
          the Service will be uninterrupted or error-free.
        </p>

        <h2>8. Suspension and termination</h2>
        <p>We may suspend or terminate your access for: material breach of these Terms, non-payment, security or fraud risk, or repeated or serious violations of acceptable use. On termination you may export your data within 30 days; afterwards we may delete it.</p>

        <h2>9. Warranties and liability</h2>
        <p>
          To the fullest extent permitted by law, the Service is provided "as is" and we disclaim all
          implied warranties (including merchantability and fitness for purpose). Our aggregate
          liability for any claim arising out of these Terms is capped at the fees you paid in the
          12 months preceding the claim. We are not liable for indirect, consequential, or special
          damages including loss of profits, data, or goodwill. Nothing in these Terms excludes
          liability for fraud, death, or personal injury where the law does not allow it.
        </p>

        <h2>10. Indemnity</h2>
        <p>You will indemnify us for claims arising from your content, unlawful use, or breach of these Terms.</p>

        <h2>11. Changes</h2>
        <p>We may update these Terms; we will notify active users by email or in-app notice for material changes.</p>

        <h2>12. Governing law</h2>
        <p>These Terms are governed by the laws of the Province of Ontario, Canada. The courts of Ontario have exclusive jurisdiction.</p>

        <h2>13. Contact</h2>
        <p>Questions about these Terms? Email support and we'll get back to you.</p>
      </article>
    </div>
  );
}